import React, { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppLayout, FormWrapper, LanguageSelector } from '@/components'
import { IReport } from '@/types'
import { print } from '@/utils'
import { t } from '@/i18n'

import { useData } from './useData'
import Form from './form'

const EditReport: React.FC = () => {
  const { id = '' } = useParams()
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const { data, loading, submitting, onSubmit } = useData({ id })

  const onSubmitForm = useCallback(
    (d: IReport) => {
      delete d.driver
      delete d.customer
      delete d.deal

      onSubmit(`reports/${id}/`, true, () => setIsEditing(false))(d)
    },
    [id, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <FormWrapper
        breadcrumbs={[{ name: isEditing ? 'edit_report' : 'view_report' }]}
        loading={loading}
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        extraButtons={[
          {
            text: t('print'),
            className: 'print-form-button',
            onClick: () => print('report', id),
          },
        ]}
      >
        <div className="content-box">
          <div className="scroll-wrap">
            <div className="content-title">
              <h2>
                {isEditing
                  ? t('edit_report_label', { label: data.id })
                  : t('view_report')}
              </h2>
            </div>
            <Form
              isEditing={isEditing}
              initialData={data}
              loading={loading}
              submitting={submitting}
              onCancel={() => setIsEditing(false)}
              onSubmit={onSubmitForm}
            />
          </div>
        </div>
      </FormWrapper>
    </AppLayout>
  )
}

export default EditReport
